<script setup lang="ts">
import merge from 'lodash-es/merge';

const { $t } = useLocalization();

const emit = defineEmits<{
    (e: 'update:modelValue', payload: any): void;
}>();

const props = defineProps<{
    modelValue: any;
    id: number;
}>();

const defaults = ref<any>({
    description: '',
    images: [{
        file: null,
        link: ''
    }],
    openInNewTab: false
});

const form = computed<FormType<any>>(() =>
{
    return props.modelValue;
});

const triggetModel = (): void =>
{
    emit('update:modelValue', form.value);
};

watch(() => props.modelValue, (value: any) =>
{
    triggetModel();
}, { deep: true });

onBeforeMount(async (): Promise<void> =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});
</script>

<template>
    <IdeoFormGroup class="widget-logo__picture" :label="$t('[[[Obrazek]]]')" :invalid-feedback="form.$errors.first(`settings.images[${id}].file`)" :state="form.$errors.state(`settings.images[${id}].file`)" required>
        <IdeoFilePicker v-model="form.settings.images[id].file" media="images" />
    </IdeoFormGroup>
    <IdeoFormGroup class="widget-logo__link" :label="$t('[[[Link]]]')" :invalid-feedback="form.$errors.first(`link`)" :state="form.$errors.state(`link`)">
        <IdeoFormInput v-model="form.settings.images[id].link" type="text" name="link" />
    </IdeoFormGroup>
    <IdeoFormGroup class="widget-logo__newTab" :invalid-feedback="form.$errors.first(`link`)" :state="form.$errors.state(`link`)">
        <IdeoFormCheckbox v-model="form.settings.images[id].openInNewTab" name="openInNewTab">
            {{ $t('[[[Otwórz w nowym oknie]]]') }}
        </IdeoFormCheckbox>
    </IdeoFormGroup>
</template>
